/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { Icon, TextField } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import Classnames from 'classnames';
import { withI18n } from '@shopify/react-i18n';

import MenuDeveloperFolder from './menu-developer-folder';
import { TEMPLATE_VALUE } from 'src/constants/shopify-integration';
import * as ShopifyIntegrationSettingsAction from 'src/stores/actions/shopify-integration/shopify-integration-settings-actions';

type Props = {};

type ComposedProps = Props & WithI18nProps;

type State = {};

class MenuDeveloper extends Component<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      filteredWidgets: _.get(props.instantWidget, 'widgets', {})
    };
  }

  componentWillReceiveProps(nextProps) {
    const { instantWidget } = this.props;
    const { instantWidget: nextInstantWidget } = nextProps;
    if (instantWidget !== nextInstantWidget) {
      this.handleSearchFile(this.state.search, nextProps);
    }
  }

  handleSelectMenu = menuItem => {
    this.props.updateFieldReducer('activeMenuItem', menuItem.value);
  };

  handleChangeSearch = value => {
    this.setState({
      search: value
    });
    this.handleSearchFile(value);
  };

  handleClearSearch = () => {
    this.setState({
      search: ''
    });
    this.handleSearchFile('');
  };

  handleSearchFile = _.debounce((value, props) => {
    const { instantWidget } = props || this.props;
    const { search } = this.state;
    const widgets = _.get(instantWidget, 'widgets', {});

    if (!value) {
      this.setState({
        filteredWidgets: widgets
      });
      return;
    }

    const filteredWidgets = {};
    Object.keys(widgets).forEach(key => {
      const arrayWidgetItem = widgets[key].filter(item =>
        item?.widgetName?.toLowerCase()?.includes(search.toLowerCase())
      );
      filteredWidgets[key] = arrayWidgetItem;
    });

    this.setState({
      filteredWidgets
    });
  }, 500);

  render() {
    const { i18n, instantWidget, codeEditTemplate } = this.props;
    const { search, filteredWidgets } = this.state;
    const menuClass = Classnames('visual-editor-menu-developer');

    const widgetIds = _.get(instantWidget, 'widgetIds', {});
    const widgetKeys = Object.keys(_.get(instantWidget, 'widgetIds', {})).filter(key =>
      [TEMPLATE_VALUE.COLLECTION, TEMPLATE_VALUE.SEARCH].includes(key)
    );

    return (
      <div className={menuClass}>
        <div className="title-wrapper">
          <h2 className="menu-title">
            {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Developer.title')}
          </h2>
        </div>

        <div className="menu-container">
          <div className="menu-container__search">
            <TextField
              onChange={this.handleChangeSearch}
              value={search}
              prefix={<Icon source={SearchMinor} color="base" />}
              placeholder={i18n.translate('AdminHTML.Common.Action.search')}
              clearButton
              onClearButtonClick={this.handleClearSearch}
            />
          </div>

          {!!widgetKeys.length &&
            widgetKeys
              .filter(field => !_.isEmpty(filteredWidgets[widgetIds[field]]))
              .map(field => {
                return (
                  <MenuDeveloperFolder
                    name={field}
                    key={widgetIds[field]}
                    widgets={filteredWidgets[widgetIds[field]]}
                    searching={!!search}
                    codeEditTemplate={codeEditTemplate}
                  />
                );
              })}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFieldReducer: (fieldName, data) =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateField(fieldName, data)),
  updateMultiFieldsReducer: data =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateMultiFields(data))
});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('ShopifyIntegrationSettingsVisualEditorForm')(state) || {};
  const instantWidget = _.get(formValues, 'instantWidget', {});

  return {
    formValues,
    instantWidget,
    enableCustomization: _.get(state, 'shopifyIntegrationSettings.enableCustomization', false),
    codeEditTemplate: _.get(state, 'shopifyIntegrationSettings.codeEditTemplate', {}),
    selectedPage: _.get(state, 'shopifyIntegrationSettings.selectedPage', '')
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(MenuDeveloper));
